import { render, staticRenderFns } from "./ResearchRegionDotsVector.vue?vue&type=template&id=38ff0578"
import script from "./ResearchRegionDotsVector.vue?vue&type=script&lang=js"
export * from "./ResearchRegionDotsVector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ff0578')) {
      api.createRecord('38ff0578', component.options)
    } else {
      api.reload('38ff0578', component.options)
    }
    module.hot.accept("./ResearchRegionDotsVector.vue?vue&type=template&id=38ff0578", function () {
      api.rerender('38ff0578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchRegionDotsVector.vue"
export default component.exports